import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './lib/api';
import { Layout } from './components/Layout/Layout';
import { HomePage } from './pages/HomePage';
import { SpeciesPage } from './pages/SpeciesPage';
import { AssessmentPage } from './pages/AssessmentPage';
import { CommunityPage } from './pages/CommunityPage';
import { AboutPage } from './pages/AboutPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from './components/ui/Toaster';

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router>
          <div className="App">
            <Routes>
              {/* Home page uses the new MapLayout design */}
              <Route path="/" element={<HomePage />} />
              
              {/* Other pages still use the old layout */}
              <Route path="/species" element={
                <Layout>
                  <SpeciesPage />
                </Layout>
              } />
              <Route path="/assess" element={
                <Layout>
                  <AssessmentPage />
                </Layout>
              } />
              <Route path="/community" element={
                <Layout>
                  <CommunityPage />
                </Layout>
              } />
              <Route path="/about" element={
                <Layout>
                  <AboutPage />
                </Layout>
              } />
            </Routes>
            <Toaster />
          </div>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
